module.exports = __webpack_public_path__ + "static/media/ecos_Logo_Stuttgart_CMYK.4f502df8.png";